module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_WoodMatted_MockedUp.ef38969f.jpg";